import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetrics = () => {
  const metrics = [
    { icon: 'Clock', value: '< 2h', label: 'Temps de réponse moyen', color: '#22d3ee' },
    { icon: 'Users', value: '2,500+', label: 'Clients satisfaits', color: '#22c55e' },
    { icon: 'Star', value: '4.9/5', label: 'Note moyenne', color: '#eab308' },
    { icon: 'CheckCircle2', value: '98%', label: 'Taux de résolution', color: '#22c55e' }
  ];

  return (
    <section className="marketing-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <p className="marketing-kicker mb-4">La preuve par les résultats</p>
          <h2 className="marketing-title text-3xl lg:text-5xl font-heading font-bold mb-4">
            Des performances qui parlent d'elles-mêmes
          </h2>
          <p className="marketing-muted text-lg">
            La satisfaction de nos clients est notre priorité
          </p>
        </div>
        
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {metrics?.map((metric, index) => (
            <div 
              key={index}
              className="marketing-card text-center p-6"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ background: `rgba(59, 130, 246, 0.1)` }}>
                <Icon name={metric?.icon} size={28} style={{ color: metric.color }} />
              </div>
              <div className="text-3xl font-bold text-white mb-2" style={{ color: metric.color }}>
                {metric?.value}
              </div>
              <div className="marketing-muted text-sm">
                {metric?.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PerformanceMetrics;